import React from 'react';
import { Modal} from 'react-bootstrap';
import CustomTable from './CustomTable';


const ReportedUserTable = ({ name, reportedUsers,  showReportedTableDialog, setShowReportedTableDialog}) => {
    const handleHide = () => {
        setShowReportedTableDialog(false)
    }
      const colDefs = [
        { field: "userId", flex: 1.2, headerName: 'Reported By', valueFormatter: (params) => params.value.firstName + " " + params.value.lastName},
        { field: "reportReason", flex: 2, filter: false, headerName: 'Report Reason' },
      ];

  return (
    <Modal show={showReportedTableDialog} onHide={() => handleHide()} size='lg' centered>
      <Modal.Header className="dialog-header" closeButton>
        <Modal.Title>Social media reported user details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomTable colDefs={colDefs} rowData={reportedUsers} />
      </Modal.Body>
    </Modal>
  );
};

export default ReportedUserTable;
